import { FormProvider, useForm } from "react-hook-form";

import { Button } from "@pentabd/ui";

import { SelectEmployee } from "./SelectEmployee";

import { useLanguage } from "@hooks/useLanguage";

interface SelectEmployeeFormProps {
  action: (arg: any) => void;
  registeredName: string;
  isLoading?: boolean;
}

export const SelectEmployeeForm = ({
  action,
  registeredName,
  isLoading,
}: SelectEmployeeFormProps) => {
  const { language } = useLanguage();

  const methods = useForm();

  const onSubmit = (data: any) => {
    action(data);
  };

  return (
    <FormProvider {...methods}>
      <form className="container" onSubmit={methods.handleSubmit(onSubmit)}>
        <SelectEmployee
          registeredName={registeredName}
          selectSingleEmployee
          forModal
        />
        <div className="d-flex justify-content-end gap-6 mt-10">
          <Button
            size="sm"
            htmlType="submit"
            fill="fill"
            type="primary"
            loading={isLoading}
          >
            {language === "bn" ? "জমা দিন" : "Submit"}
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};
